<mat-form-field class="common-search-field hide-mat-error-field" [floatLabel]="'never'" appearance="outline">
    <i class="fas fa-search search-icon" matPrefix></i>
    <input class="searchTextField" matInput [placeholder]="inputPlaceholder" [disabled]="disabled" [(ngModel)]="searchValue" (keydown.enter)="onEnterPress(searchValue)" (ngModelChange)="search($event)"
        autocomplete="off" />
    <i class="fas fa-times cross-icon" (mousedown)="$event.preventDefault()" (click)="clearFilterSearch(); $event.stopPropagation();"
        *ngIf="!disabled && searchValue.length > 0" aria-hidden="true" id="clearSearchIcon" matSuffix></i>
</mat-form-field>
